import { useRef, useState } from 'react'

import { EMPTY_LIST } from '../../../../../../constants/common'
import { toPhotoFormValues } from '../../../../RentalPortalPhotoGallery'
import { useListingProfileContext } from '../useListingProfileContext'

import { getCanEditListingProfilePhotos } from './useListingProfilePhotoEditorOpener.utils'

export function useListingProfilePhotoEditorOpener() {
  const [isPhotoEditorOpen, setIsPhotoEditorOpen] = useState(false)

  const openerRef = useRef(null)

  const { handleEntityReload, isPreview, listingData } =
    useListingProfileContext()

  const canEditPhotos = getCanEditListingProfilePhotos({
    isPreview,
    listingData,
  })

  function handleClosePhotoEditor() {
    setIsPhotoEditorOpen(false)

    openerRef.current?.focus()
    openerRef.current = null
  }

  function handleOpenPhotoEditor(event) {
    if (canEditPhotos) {
      openerRef.current = event?.currentTarget ?? null

      setIsPhotoEditorOpen(true)
    }
  }

  async function handleSavePhotoEditor() {
    const opener = openerRef.current

    openerRef.current = null

    setIsPhotoEditorOpen(false)

    await handleEntityReload()

    if (opener?.isConnected) {
      opener.focus()
    }
  }

  return {
    canEditPhotos,
    handleOpenPhotoEditor,
    isPhotoEditorOpen,
    photoEditorProps: {
      initialPhotos: toPhotoFormValues(listingData?.photos ?? EMPTY_LIST),
      listingId: listingData?.id,
      onClose: handleClosePhotoEditor,
      onReload: handleEntityReload,
      onSave: handleSavePhotoEditor,
    },
  }
}
